__turbopack_context__.v({
  "code": "DemoLiveContent-module__YG0RUa__code",
  "codeBlock": "DemoLiveContent-module__YG0RUa__codeBlock",
  "codeSection": "DemoLiveContent-module__YG0RUa__codeSection",
  "container": "DemoLiveContent-module__YG0RUa__container",
  "demoSection": "DemoLiveContent-module__YG0RUa__demoSection",
  "demoSurface": "DemoLiveContent-module__YG0RUa__demoSurface",
  "fileRefs": "DemoLiveContent-module__YG0RUa__fileRefs",
  "header": "DemoLiveContent-module__YG0RUa__header",
  "headerActions": "DemoLiveContent-module__YG0RUa__headerActions",
  "headerContainer": "DemoLiveContent-module__YG0RUa__headerContainer",
  "resetButton": "DemoLiveContent-module__YG0RUa__resetButton",
  "switchContainer": "DemoLiveContent-module__YG0RUa__switchContainer",
  "switchContainerHidden": "DemoLiveContent-module__YG0RUa__switchContainerHidden",
  "tabContainer": "DemoLiveContent-module__YG0RUa__tabContainer",
});
